import _slicedToArray from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback, useMemo } from 'react';
import { createWidthCalculator } from '../../widthCalculator/index.js';
import { getViewMetricsFromContainer } from './getViewMetrics.js';
import { objectUnzip } from '../../helpers/object.js';
export function useWidthCalculator() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    baseMetrics = _useState2[0],
    setBaseMetrics = _useState2[1];
  var resetCalculator = useCallback(function () {
    return setBaseMetrics(null);
  }, []);
  var calculatorResult = useMemo(function () {
    return createWidthCalculator(baseMetrics);
  }, [baseMetrics]);
  if ('requiredBaseMetrics' in calculatorResult) {
    var _objectUnzip = objectUnzip(calculatorResult.requiredBaseMetrics),
      _objectUnzip2 = _slicedToArray(_objectUnzip, 2),
      itemKeys = _objectUnzip2[0],
      items = _objectUnzip2[1];
    return {
      renderNeeded: {
        items: items,
        ref: function ref(containerElement) {
          if (containerElement) {
            setBaseMetrics(getViewMetricsFromContainer(containerElement, itemKeys));
          }
        }
      },
      clearCache: resetCalculator
    };
  }
  return {
    calculator: calculatorResult,
    clearCache: resetCalculator
  };
}